<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <OrganizationalTree ref="organizationalTree" :nodeSelectProp='getNode' :neid="neid">
        <template v-slot:organizationalIcon_solt>
          <OrganizationalIcon ></OrganizationalIcon>
        </template>
      </OrganizationalTree>
    </template>
    <template v-slot:right_view>
      <UserTableMenu @methodEnum='methodEnum' ref="userTableMenu"></UserTableMenu>
      <ImsUserTable ref="usertable"></ImsUserTable>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../../layouts/BasicLayout';
import OrganizationalTree from '../../../../components/subscriberconfig/util/OrganizationalTree';
import OrganizationalIcon from '../../../../components/subscriberconfig/util/OrganizationalIcon';
import ImsUserTable from '../../../../components/subscriberconfig/imsSubscriber/user/ImsUserTable';
import UserTableMenu from '../../../../components/subscriberconfig/imsSubscriber/user/ImsUserTableMenu';

export default {
  name: 'imsUserManagement',
  components: {
    BasicLayout,
    OrganizationalTree,
    OrganizationalIcon,
    ImsUserTable,
    UserTableMenu
  },
  data() {
    return {
      neid: null,
      node:'',
      left: {
        show: true,
        name:this.$t('SubscriberIms.organization')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb:this.$t('SubscriberIms.menuTitleUser')
      },
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'add':
          this.$refs.usertable.openAddImsUserPage(opcode);
          break;
        case 'batchAdd':
          this.$refs.usertable.openAddImsUserPage(opcode);
          break;
        case 'mod':
          this.$refs.usertable.openModImsUserPage(opcode);
          break;
        case 'batchMod':
          this.$refs.usertable.openModImsUserPage(opcode);
          break;
        case 'del':
          this.$refs.usertable.delImsUsers(opcode);
          break;
        case 'refresh':
          this.$refs.usertable.clearQryParam();
          this.$refs.usertable.getGridData(this.node);
          break;
        case 'addUserMember':
          this.$refs.usertable.openAddImsUserMemberPage(opcode);
          break;
        case 'qryUserMember':
          this.$refs.usertable.openQryImsUserMemberPage(opcode);
          break;
        case 'import':
          this.$refs.usertable.openImportUserPage();
          break;
        case 'export':
          this.$refs.usertable.exportImsUser();
          break;
        case 'search':
          this.$refs.usertable.openQryImsUserPage(opcode);
          break;
        default:
      }
    },
    getNode(node) {
      this.$refs.usertable.getGridData(node);
      this.$refs.usertable.clearQryParam();
      this.node = node;
    },
    treeFresh(node) {
      this.$refs.usertable.clearGridData();
      this.$refs.usertable.clearQryParam();
      // 若组织架构刷新后有默认值则执行数据查询
      this.$refs.usertable.getGridData(node);
    },
  },
  mounted() {
    this.$refs.organizationalTree.getOrganizationalTree();
  }
};
</script>

<style scoped>

</style>
